
(function() {
  'use strict';
 
  function isWeekend(date) {
    var day = date.getDay();
    return day === 0 || day === 6;
  }

  function getNextBusinessDay(date, daysToAdd) {
    var result = new Date(date);
    var daysAdded = 0;
   
    while (daysAdded < daysToAdd) {
      result.setDate(result.getDate() + 1);
      if (!isWeekend(result)) {
        daysAdded++;
      }
    }
    return result;
  }

  function calculateDeliveryDate(daysToAdd, cutoffHour, cutoffMinute, isAfterCutoff) {
    var now = new Date();
    var currentDay = now.getDay();
   
    // Saturday (6) or Sunday (0)
    if (currentDay === 6 || currentDay === 0) {
      var tuesday = new Date(now);
      var daysToTuesday = currentDay === 6 ? 3 : 2;
      tuesday.setDate(tuesday.getDate() + daysToTuesday);
      return { date: tuesday, isTomorrow: false };
    }
   
    // Friday after cutoff
    if (currentDay === 5 && isAfterCutoff) {
      var tuesday = new Date(now);
      tuesday.setDate(tuesday.getDate() + 4);
      return { date: tuesday, isTomorrow: false };
    }
   
    // Regular business day logic
    var startDate = new Date(now);
   
    if (isAfterCutoff) {
      startDate.setDate(startDate.getDate() + 1);
      while (isWeekend(startDate)) {
        startDate.setDate(startDate.getDate() + 1);
      }
    }
   
    var deliveryDate = getNextBusinessDay(startDate, daysToAdd);
    var tomorrow = new Date(now);
    tomorrow.setDate(tomorrow.getDate() + 1);
    var isTomorrow = deliveryDate.toDateString() === tomorrow.toDateString() && !isAfterCutoff && daysToAdd === 1;
   
    return { date: deliveryDate, isTomorrow: isTomorrow };
  }

  function formatDateWithSuffix(date, isTomorrow) {
    var day = date.getDate();
    var suffix = 'th';
    if (day % 100 < 11 || day % 100 > 13) {
      switch (day % 10) {
        case 1: suffix = 'st'; break;
        case 2: suffix = 'nd'; break;
        case 3: suffix = 'rd'; break;
      }
    }
   
    if (isTomorrow) {
      return 'Tomorrow, ' + day + suffix + ' ' + date.toLocaleDateString('en-GB', { month: 'short' });
    }
    return date.toLocaleDateString('en-GB', { weekday: 'long' }) + ', ' + day + suffix + ' ' + date.toLocaleDateString('en-GB', { month: 'short' });
  }

  function formatHeaderDeliveryLabel(date, isTomorrow) {
    if (isTomorrow) {
      return '"TOMORROW"';
    }
    var weekday = date.toLocaleDateString('en-GB', { weekday: 'long' }).toUpperCase();
    return '"' + weekday + '"';
  }

  function initHeaderOrderTimers() {
    var blocks = document.querySelectorAll('.header-order-timer[data-initialized="false"]');

    blocks.forEach(function(block) {
      block.setAttribute('data-initialized', 'true');

      var timerEl = block.querySelector('.header-order-timer__countdown');
      var dateEl = block.querySelector('.header-order-timer__delivery');

      if (!timerEl || !dateEl) return;

      var cutoffTime = block.getAttribute('data-cutoff-time') || '17:00';
      var daysToAdd = parseInt(block.getAttribute('data-delivery-days')) || 1;
      var parts = cutoffTime.split(':');
      var cutoffHour = parseInt(parts[0]) || 17;
      var cutoffMinute = parseInt(parts[1]) || 0;

      function updateDisplay() {
        var now = new Date();
        var h = now.getHours();
        var m = now.getMinutes();
        var afterCutoff = h > cutoffHour || (h === cutoffHour && m >= cutoffMinute);

        var nextCutoff = new Date();
        nextCutoff.setHours(cutoffHour, cutoffMinute, 0, 0);
        if (afterCutoff) {
          nextCutoff.setDate(nextCutoff.getDate() + 1);
        }

        var diff = nextCutoff - now;
        if (diff > 0) {
          var hours = Math.floor(diff / 3600000);
          var minutes = Math.floor((diff % 3600000) / 60000);
          var seconds = Math.floor((diff % 60000) / 1000);
          timerEl.textContent =
            String(hours).padStart(2, '0') +
            ':' +
            String(minutes).padStart(2, '0') +
            ':' +
            String(seconds).padStart(2, '0');
        } else {
          timerEl.textContent = '00:00:00';
        }

        var deliveryInfo = calculateDeliveryDate(daysToAdd, cutoffHour, cutoffMinute, afterCutoff);
        dateEl.textContent = formatHeaderDeliveryLabel(deliveryInfo.date, deliveryInfo.isTomorrow);
      }

      updateDisplay();
      setInterval(updateDisplay, 1000);
    });
  }

  function initDeliveryBlocks() {
    var blocks = document.querySelectorAll('.delivery-info-wrapper[data-initialized="false"]');
   
    blocks.forEach(function(block) {
      block.setAttribute('data-initialized', 'true');
     
      var timerEl = block.querySelector('.countdown-timer');
      var dateEl = block.querySelector('.delivery-date');
     
      if (!timerEl || !dateEl) return;
     
      var cutoffTime = block.getAttribute('data-cutoff-time') || '20:00';
      var daysToAdd = parseInt(block.getAttribute('data-delivery-days')) || 1;
      var parts = cutoffTime.split(':');
      var cutoffHour = parseInt(parts[0]) || 20;
      var cutoffMinute = parseInt(parts[1]) || 0;
     
      function updateDisplay() {
        var now = new Date();
        var h = now.getHours();
        var m = now.getMinutes();
        var afterCutoff = (h > cutoffHour) || (h === cutoffHour && m >= cutoffMinute);
       
        // Timer
        var nextCutoff = new Date();
        nextCutoff.setHours(cutoffHour, cutoffMinute, 0, 0);
        if (afterCutoff) {
          nextCutoff.setDate(nextCutoff.getDate() + 1);
        }
       
        var diff = nextCutoff - now;
        if (diff > 0) {
          var hours = Math.floor(diff / 3600000);
          var minutes = Math.floor((diff % 3600000) / 60000);
          var seconds = Math.floor((diff % 60000) / 1000);
          timerEl.textContent = String(hours).padStart(2, '0') + ':' +
                                 String(minutes).padStart(2, '0') + ':' +
                                 String(seconds).padStart(2, '0');
        } else {
          timerEl.textContent = '00:00:00';
        }
       
        // Delivery date with weekend logic
        var deliveryInfo = calculateDeliveryDate(daysToAdd, cutoffHour, cutoffMinute, afterCutoff);
        dateEl.textContent = formatDateWithSuffix(deliveryInfo.date, deliveryInfo.isTomorrow);
      }
     
      updateDisplay();
      setInterval(updateDisplay, 1000);
    });
  }
 
  function initAllTimers() {
    initDeliveryBlocks();
    initHeaderOrderTimers();
  }

  // Initialize when page loads
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllTimers);
  } else {
    initAllTimers();
  }
 
  // Watch for new blocks added dynamically (like in theme editor)
  var observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      mutation.addedNodes.forEach(function(node) {
        if (node.nodeType === 1) {
          if (
            (node.classList &&
              (node.classList.contains('delivery-info-wrapper') || node.classList.contains('header-order-timer'))) ||
            (node.querySelector &&
              (node.querySelector('.delivery-info-wrapper') || node.querySelector('.header-order-timer')))
          ) {
            initAllTimers();
          }
        }
      });
    });
  });
 
  observer.observe(document.body, { childList: true, subtree: true });
 
  // Shopify theme editor support
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function() {
      setTimeout(initAllTimers, 100);
    });
    document.addEventListener('shopify:block:select', function() {
      setTimeout(initAllTimers, 100);
    });
  }
})();
